// eslint-disable-next-line
export { default as moduleFactory } from './moduleFactory';



// WEBPACK FOOTER //
// ./src/scripts/lib/index.js